var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_228_9726",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_228_9726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 12.8335V11.5002H3.83333V12.8335H2.5ZM2.5 10.5002V9.16683H3.83333V10.5002H2.5ZM2.5 8.16683V6.8335H3.83333V8.16683H2.5ZM4.83333 15.1668V13.8335H6.16667V15.1668H4.83333ZM6.5 12.5002C6.13333 12.5002 5.81944 12.3696 5.55833 12.1085C5.29722 11.8474 5.16667 11.5335 5.16667 11.1668V3.16683C5.16667 2.80016 5.29722 2.48627 5.55833 2.22516C5.81944 1.96405 6.13333 1.8335 6.5 1.8335H12.5C12.8667 1.8335 13.1806 1.96405 13.4417 2.22516C13.7028 2.48627 13.8333 2.80016 13.8333 3.16683V11.1668C13.8333 11.5335 13.7028 11.8474 13.4417 12.1085C13.1806 12.3696 12.8667 12.5002 12.5 12.5002H6.5ZM6.5 11.1668H12.5V3.16683H6.5V11.1668ZM7.16667 15.1668V13.8335H8.5V15.1668H7.16667ZM3.83333 15.1668C3.46667 15.1668 3.15278 15.0363 2.89167 14.7752C2.63056 14.5141 2.5 14.2002 2.5 13.8335H3.83333V15.1668ZM9.5 15.1668V13.8335H10.8333C10.8333 14.2002 10.7028 14.5141 10.4417 14.7752C10.1806 15.0363 9.86667 15.1668 9.5 15.1668ZM2.5 5.8335C2.5 5.46683 2.63056 5.15294 2.89167 4.89183C3.15278 4.63072 3.46667 4.50016 3.83333 4.50016V5.8335H2.5Z",
    fill: "#999999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopy);
export default __webpack_public_path__ + "static/media/icCopy.107cba4ec00363e0290e4a1566aec5bd.svg";
export { ForwardRef as ReactComponent };